module.exports = __webpack_public_path__ + "img/tarjeta2.1cc16f60.svg";